export const style = {
  wrapper: {
    padding: `35px 0`,
    color: `white`,
    background: `#A94545`
  },
  label: {
    fontSize: `16px`,
    fontWeight: 300,
    paddingTop: `6px`
  },
  value: {
    fontSize: `40px`,
    fontWeight: 400,
    lineHeight: `50px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/summary.js